import { SaveFileIcon } from "@/components/common/icons/SaveFileIcon/SaveFileIcon"
import { Modal } from "@/components/common/Modal/Modal"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useNavigate } from "react-router"

interface ContinueLaterModalProps {
  setIsContinueLaterModalOpen: (isOpen: boolean) => void
}

export const ContinueLaterModal: React.FC<ContinueLaterModalProps> = ({
  setIsContinueLaterModalOpen,
}) => {
  const { translate } = useTranslation()
  const navigate = useNavigate()

  const handleSaveButton = () => {
    navigate("/history")
  }

  const handleCloseContinueLaterModal = () => {
    setIsContinueLaterModalOpen(false)
  }

  return (
    <Modal
      showSidebarLeft
      ModalIcon={SaveFileIcon}
      descriptionText={translate(
        "QUESTIONNAIRE/CONTINUE_LATER/CONTINUE_LATER_TEXT",
      )}
      primaryActionTitle={translate("QUESTIONNAIRE/CONTINUE_LATER/SAVE")}
      secondaryActionTitle={translate(
        "QUESTIONNAIRE/CONTINUE_LATER/CONTINUE_NOW",
      )}
      onClose={handleCloseContinueLaterModal}
      onPrimaryAction={handleSaveButton}
      onSecondaryAction={handleCloseContinueLaterModal}
    />
  )
}
